import { SubChildCategory } from "../../categories/categories.types";
import { AttributeTypes } from "../../categories/constants/enums";

export const getCategoryAttributesByType = (
  category: SubChildCategory | undefined,
  type: AttributeTypes
) => {
  return (
    category?.attributes?.filter((attribute) => attribute.type === type) ?? []
  );
};
